import Axios from "axios";
import { authorizationHeader } from "./apiUtils";
import { ProductInterface } from "../models/products";

const routes = {
  bracelets: "/api/bracelets",
  import: "/api/bracelets/import",
};

const getAllBracelets = async (): Promise<ProductInterface[]> => {
  const route = `${routes.bracelets}`;

  const result = await Axios.get<ProductInterface[]>(route, {
    headers: authorizationHeader(),
  });

  return result.data;
};

const getBraceletByName = async (name: string, color?: string, size?: string): Promise<ProductInterface> => {
  let route = `${routes.bracelets}/${name}`;

  const queryParams = new URLSearchParams();
  if (color) {
    queryParams.append("color", color);
  }
  if (size) {
    queryParams.append("size", size);
  }

  if (queryParams.toString()) {
    route += `?${queryParams.toString()}`;
  }

  const result = await Axios.get<ProductInterface>(route, {
    headers: authorizationHeader(),
  });

  return result.data;
};

// const addGenericDiamond = async (diamond: UpsertGenericDiamond): Promise<UpsertGenericDiamond> => {
//   const result = await Axios.post<UpsertGenericDiamond>(routes.genericDiamonds, diamond, {
//     headers: authorizationHeader(),
//   });

//   return result.data;
// };

// const editGenericDiamond = async (id: number, model: UpsertGenericDiamond): Promise<void> => {
//   const route = routes.genericDiamond.replace("{id}", id.toString());
//   await Axios.patch(route, model, {
//     headers: authorizationHeader(),
//   });
// };

const importCsv = async (file: File): Promise<void> => {
  const formData = new FormData();
  formData.append("file", file);

  await Axios.post(routes.import, formData, {
    headers: authorizationHeader(),
  });
};

export { getAllBracelets, getBraceletByName, importCsv };
